import { render, staticRenderFns } from "./RaceTableColumn.vue?vue&type=template&id=6fb3f9b6"
import script from "./RaceTableColumn.vue?vue&type=script&lang=js"
export * from "./RaceTableColumn.vue?vue&type=script&lang=js"
import style0 from "./RaceTableColumn.vue?vue&type=style&index=0&id=6fb3f9b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports